// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__+8Cdl","left":"Virtual_left__IUnsZ","wrapper":"Virtual_wrapper__AF9qA"};